// Practice Questions Database - 200+ PCEP-aligned questions
// Organized by PCEP syllabus blocks for targeted practice

export const practiceQuestions = {
  // Block 1: Computer Programming Basics (18% - ~36 questions)
  "basics": {
    title: "Computer Programming Basics",
    description: "Python fundamentals, syntax, and basic concepts",
    questions: [
      {
        question: "What is Python primarily known as?",
        options: [
          "A compiled language",
          "A high-level, interpreted, general-purpose programming language",
          "A low-level assembly language",
          "A database management system"
        ],
        correctAnswer: 1,
        explanation: "Python is a high-level, interpreted language known for readability and versatility."
      },
      {
        question: "Which of the following is a valid Python comment?",
        options: [
          "// This is a comment",
          "# This is a comment",
          "/* This is a comment */",
          "<!-- This is a comment -->"
        ],
        correctAnswer: 1,
        explanation: "Python uses # for single-line comments. Multi-line comments use triple quotes."
      },
      {
        question: "What does 'print()' do in Python?",
        options: [
          "Creates a new variable",
          "Outputs data to the console",
          "Saves data to a file",
          "Deletes data"
        ],
        correctAnswer: 1,
        explanation: "print() displays output to the console/terminal."
      },
      {
        question: "What is indentation used for in Python?",
        options: [
          "Only for aesthetics",
          "To define code blocks and scope",
          "To create comments",
          "To separate statements"
        ],
        correctAnswer: 1,
        explanation: "Indentation is syntactically significant in Python - it defines code blocks."
      },
      {
        question: "Which Python version introduced many breaking changes?",
        options: [
          "Python 2.7",
          "Python 3.0",
          "Python 1.0",
          "Python 4.0"
        ],
        correctAnswer: 1,
        explanation: "Python 3.0 introduced significant changes incompatible with Python 2.x."
      },
      {
        question: "What is the correct file extension for Python files?",
        options: [
          ".python",
          ".py",
          ".pt",
          ".pyt"
        ],
        correctAnswer: 1,
        explanation: "Python source files use the .py extension."
      },
      {
        question: "Which keyword is NOT a Python keyword?",
        options: [
          "def",
          "function",
          "class",
          "import"
        ],
        correctAnswer: 1,
        explanation: "Python uses 'def', not 'function', to define functions."
      },
      {
        question: "What is the purpose of the '__name__' variable?",
        options: [
          "To store the user's name",
          "To determine if a script is run directly or imported",
          "To define class names",
          "To create variables"
        ],
        correctAnswer: 1,
        explanation: "__name__ is '__main__' when a script runs directly, otherwise it's the module name."
      },
      {
        question: "How do you execute a Python script from the command line?",
        options: [
          "run script.py",
          "python script.py",
          "execute script.py",
          "start script.py"
        ],
        correctAnswer: 1,
        explanation: "Use 'python script.py' or 'python3 script.py' to run Python scripts."
      },
      {
        question: "What is the Python interactive mode?",
        options: [
          "A gaming mode",
          "A REPL where you can test code line by line",
          "A debugging tool only",
          "An IDE"
        ],
        correctAnswer: 1,
        explanation: "The Python REPL (Read-Eval-Print Loop) allows interactive code execution."
      },
      {
        question: "Which statement about Python is FALSE?",
        options: [
          "Python is case-sensitive",
          "Python requires semicolons at the end of statements",
          "Python uses dynamic typing",
          "Python supports object-oriented programming"
        ],
        correctAnswer: 1,
        explanation: "Python doesn't require semicolons (though they're allowed)."
      },
      {
        question: "What does 'Zen of Python' refer to?",
        options: [
          "A meditation technique",
          "A collection of guiding principles for Python design",
          "A Python framework",
          "A debugging tool"
        ],
        correctAnswer: 1,
        explanation: "The Zen of Python (PEP 20) lists 19 guiding principles for Python design."
      },
      {
        question: "How do you view the Zen of Python?",
        options: [
          "print('zen')",
          "import this",
          "show zen",
          "python --zen"
        ],
        correctAnswer: 1,
        explanation: "'import this' displays the Zen of Python in the interpreter."
      },
      {
        question: "What is PEP?",
        options: [
          "Python Error Protocol",
          "Python Enhancement Proposal",
          "Python Execution Process",
          "Python Extension Package"
        ],
        correctAnswer: 1,
        explanation: "PEPs are design documents providing information or describing new Python features."
      },
      {
        question: "Which of these follows PEP 8 naming for a function?",
        options: [
          "CalculateSum",
          "calculate_sum",
          "calculateSum",
          "CALCULATE_SUM"
        ],
        correctAnswer: 1,
        explanation: "PEP 8 recommends snake_case for function names."
      },
      {
        question: "What is the Python Standard Library?",
        options: [
          "A book about Python",
          "A collection of modules included with Python",
          "A third-party package manager",
          "An IDE"
        ],
        correctAnswer: 1,
        explanation: "The Standard Library is a collection of modules that come with Python."
      },
      {
        question: "How many spaces does PEP 8 recommend for indentation?",
        options: [
          "2",
          "4",
          "8",
          "Tab character"
        ],
        correctAnswer: 1,
        explanation: "PEP 8 recommends 4 spaces per indentation level."
      },
      {
        question: "Can you mix tabs and spaces for indentation?",
        options: [
          "Yes, always",
          "No, this causes IndentationError or inconsistent behavior",
          "Only in Python 2",
          "Only in functions"
        ],
        correctAnswer: 1,
        explanation: "Mixing tabs and spaces causes errors and is against PEP 8."
      },
      {
        question: "What is a literal in Python?",
        options: [
          "A variable name",
          "A fixed value written directly in code (e.g., 5, 'hello')",
          "A function",
          "An operator"
        ],
        correctAnswer: 1,
        explanation: "Literals are fixed values like numbers, strings, booleans written in source code."
      },
      {
        question: "Which is a valid Python identifier?",
        options: [
          "2variable",
          "_variable",
          "variable-name",
          "variable name"
        ],
        correctAnswer: 1,
        explanation: "Identifiers can start with underscore or letter, but not digits, and can't contain spaces/hyphens."
      },
      {
        question: "What is the output of: print(type(10))?",
        options: [
          "int",
          "<class 'int'>",
          "integer",
          "10"
        ],
        correctAnswer: 1,
        explanation: "type() returns the type object, printed as <class 'type_name'>."
      },
      {
        question: "What does 'duck typing' mean in Python?",
        options: [
          "Using ducks in code",
          "If it walks like a duck and quacks like a duck, it's a duck (focus on behavior, not type)",
          "A type of error",
          "A debugging technique"
        ],
        correctAnswer: 1,
        explanation: "Duck typing means Python cares about what an object can do, not what type it is."
      },
      {
        question: "What is CPython?",
        options: [
          "Python written in C++",
          "The reference implementation of Python written in C",
          "A Python compiler",
          "A Python framework"
        ],
        correctAnswer: 1,
        explanation: "CPython is the default and most widely-used Python implementation, written in C."
      },
      {
        question: "What are bytecode files (.pyc)?",
        options: [
          "Source code files",
          "Compiled Python code that the interpreter executes",
          "Configuration files",
          "Documentation files"
        ],
        correctAnswer: 1,
        explanation: ".pyc files contain bytecode - the compiled version of Python source code."
      },
      {
        question: "What is the purpose of the pass statement?",
        options: [
          "To skip a loop iteration",
          "A null operation placeholder that does nothing",
          "To exit a function",
          "To raise an exception"
        ],
        correctAnswer: 1,
        explanation: "'pass' is a placeholder that does nothing - useful when syntax requires a statement."
      },
      {
        question: "Can Python code span multiple lines?",
        options: [
          "No, never",
          "Yes, using backslash (\\) or implicit line continuation in brackets",
          "Only in functions",
          "Only with semicolons"
        ],
        correctAnswer: 1,
        explanation: "Use \\ for explicit continuation or implicit continuation inside (), [], {}."
      },
      {
        question: "What is the difference between '==' and 'is'?",
        options: [
          "No difference",
          "'==' compares values; 'is' compares identity (same object in memory)",
          "'is' is deprecated",
          "They work on different types"
        ],
        correctAnswer: 1,
        explanation: "== checks value equality; 'is' checks if two variables reference the same object."
      },
      {
        question: "What does 'None' represent in Python?",
        options: [
          "Zero",
          "The absence of a value or null value",
          "An empty string",
          "False"
        ],
        correctAnswer: 1,
        explanation: "None is Python's null value, representing the absence of a value."
      },
      {
        question: "Is None the same as False?",
        options: [
          "Yes, they're identical",
          "No, None is not equal to False (though both are falsy)",
          "Only in Python 2",
          "Only in boolean context"
        ],
        correctAnswer: 1,
        explanation: "None and False are different values, though both evaluate to False in boolean context."
      },
      {
        question: "What is a Python package?",
        options: [
          "A compressed file",
          "A directory containing modules and an __init__.py file",
          "A single .py file",
          "A database"
        ],
        correctAnswer: 1,
        explanation: "A package is a directory with an __init__.py file that organizes related modules."
      },
      {
        question: "What command checks the Python version?",
        options: [
          "python --about",
          "python --version",
          "python -v",
          "version()"
        ],
        correctAnswer: 1,
        explanation: "'python --version' or 'python -V' displays the installed Python version."
      },
      {
        question: "What is pip?",
        options: [
          "A Python IDE",
          "Python's package installer for managing third-party packages",
          "A Python keyword",
          "A data type"
        ],
        correctAnswer: 1,
        explanation: "pip is the standard package manager for installing and managing Python packages."
      },
      {
        question: "How do you install a package using pip?",
        options: [
          "pip get package_name",
          "pip install package_name",
          "pip download package_name",
          "install package_name"
        ],
        correctAnswer: 1,
        explanation: "'pip install package_name' installs packages from PyPI."
      },
      {
        question: "What is PyPI?",
        options: [
          "Python Programming Interface",
          "Python Package Index - a repository of Python packages",
          "A Python IDE",
          "A testing framework"
        ],
        correctAnswer: 1,
        explanation: "PyPI (Python Package Index) is the official repository for third-party Python packages."
      },
      {
        question: "What is a virtual environment in Python?",
        options: [
          "A cloud service",
          "An isolated Python environment with its own packages and dependencies",
          "A testing tool",
          "A debugging mode"
        ],
        correctAnswer: 1,
        explanation: "Virtual environments isolate project dependencies to avoid conflicts between projects."
      },
      {
        question: "Which tool creates virtual environments?",
        options: [
          "pip",
          "venv or virtualenv",
          "python-env",
          "isolate"
        ],
        correctAnswer: 1,
        explanation: "'venv' (built-in) or 'virtualenv' create isolated Python environments."
      }
    ]
  },

  // Block 2: Data Types, Variables, Operators, I/O (29% - ~58 questions)
  "datatypes": {
    title: "Data Types, Variables, Operators & I/O",
    description: "Numbers, strings, booleans, operators, and input/output",
    questions: [
      {
        question: "Which of these is NOT a numeric type in Python?",
        options: [
          "int",
          "decimal",
          "float",
          "complex"
        ],
        correctAnswer: 1,
        explanation: "Python has int, float, and complex. Use the 'decimal' module for Decimal type."
      },
      {
        question: "What is the result of 5 / 2 in Python 3?",
        options: [
          "2",
          "2.5",
          "3",
          "Error"
        ],
        correctAnswer: 1,
        explanation: "/ performs float division in Python 3, returning 2.5."
      },
      {
        question: "What is the result of 5 // 2?",
        options: [
          "2.5",
          "2",
          "3",
          "1"
        ],
        correctAnswer: 1,
        explanation: "// performs floor division, returning only the integer part: 2."
      },
      {
        question: "What does the % operator do?",
        options: [
          "Division",
          "Returns the remainder of division (modulo)",
          "Percentage calculation",
          "Multiplication"
        ],
        correctAnswer: 1,
        explanation: "% is the modulo operator, returning the remainder: 5 % 2 = 1."
      },
      {
        question: "What is 2 ** 10?",
        options: [
          "20",
          "1024",
          "100",
          "12"
        ],
        correctAnswer: 1,
        explanation: "** is exponentiation: 2^10 = 1024."
      },
      {
        question: "How do you create a complex number in Python?",
        options: [
          "3 + 4i",
          "3 + 4j or complex(3, 4)",
          "complex(3, 4i)",
          "3 + 4*i"
        ],
        correctAnswer: 1,
        explanation: "Use 'j' suffix or complex() function: 3+4j or complex(3,4)."
      },
      {
        question: "What is the result of abs(-5)?",
        options: [
          "-5",
          "5",
          "0",
          "Error"
        ],
        correctAnswer: 1,
        explanation: "abs() returns the absolute value: abs(-5) = 5."
      },
      {
        question: "What does round(3.7) return?",
        options: [
          "3",
          "4",
          "3.7",
          "Error"
        ],
        correctAnswer: 1,
        explanation: "round() rounds to the nearest integer: round(3.7) = 4."
      },
      {
        question: "How do you convert a string '123' to an integer?",
        options: [
          "string.toInt()",
          "int('123')",
          "integer('123')",
          "convert('123')"
        ],
        correctAnswer: 1,
        explanation: "int() converts strings to integers: int('123') = 123."
      },
      {
        question: "What happens if you do int('abc')?",
        options: [
          "Returns 0",
          "Raises ValueError",
          "Returns None",
          "Returns 'abc'"
        ],
        correctAnswer: 1,
        explanation: "int() raises ValueError when the string doesn't contain a valid number."
      },
      {
        question: "What is the type of True in Python?",
        options: [
          "boolean",
          "bool",
          "int",
          "string"
        ],
        correctAnswer: 1,
        explanation: "Boolean values have type 'bool': type(True) = <class 'bool'>."
      },
      {
        question: "Is True equal to 1 in Python?",
        options: [
          "No, never",
          "Yes, True == 1 evaluates to True",
          "Only sometimes",
          "It's an error"
        ],
        correctAnswer: 1,
        explanation: "In Python, True == 1 and False == 0 because bool is a subclass of int."
      },
      {
        question: "What are the only boolean values in Python?",
        options: [
          "true, false",
          "True, False (capitalized)",
          "1, 0",
          "yes, no"
        ],
        correctAnswer: 1,
        explanation: "Python has exactly two boolean values: True and False (case-sensitive)."
      },
      {
        question: "Which of these is falsy in Python?",
        options: [
          "'False'",
          "0, None, [], '', False",
          "1",
          "''"
        ],
        correctAnswer: 1,
        explanation: "Falsy values: False, None, 0, 0.0, '', [], {}, (). All others are truthy."
      },
      {
        question: "What is string concatenation?",
        options: [
          "Removing strings",
          "Joining strings together using +",
          "Comparing strings",
          "Converting strings"
        ],
        correctAnswer: 1,
        explanation: "Concatenation joins strings: 'Hello' + ' ' + 'World' = 'Hello World'."
      },
      {
        question: "What does 'abc' * 3 produce?",
        options: [
          "'abc3'",
          "'abcabcabc'",
          "'aaa bbb ccc'",
          "Error"
        ],
        correctAnswer: 1,
        explanation: "String * int repeats the string: 'abc' * 3 = 'abcabcabc'."
      },
      {
        question: "How do you access the first character of string s?",
        options: [
          "s.first()",
          "s[0]",
          "s{0}",
          "s(0)"
        ],
        correctAnswer: 1,
        explanation: "Use indexing with square brackets: s[0] gets the first character."
      },
      {
        question: "What is the index of the last character in string s?",
        options: [
          "s.length - 1",
          "s[-1] or len(s) - 1",
          "s[end]",
          "s.last"
        ],
        correctAnswer: 1,
        explanation: "Use negative index -1 or len(s)-1 to access the last character."
      },
      {
        question: "What does len('Hello') return?",
        options: [
          "4",
          "5",
          "6",
          "'Hello'"
        ],
        correctAnswer: 1,
        explanation: "len() returns the number of characters: len('Hello') = 5."
      },
      {
        question: "What is an escape sequence?",
        options: [
          "A security feature",
          "Special character combinations starting with \\ (e.g., \\n, \\t)",
          "A loop exit",
          "An error handler"
        ],
        correctAnswer: 1,
        explanation: "Escape sequences represent special characters: \\n (newline), \\t (tab), \\\\ (backslash)."
      },
      {
        question: "What does '\\n' represent?",
        options: [
          "The letter n",
          "A newline (line break)",
          "Nothing",
          "Null"
        ],
        correctAnswer: 1,
        explanation: "\\n is the newline escape sequence, creating a line break."
      },
      {
        question: "How do you create a multi-line string literal?",
        options: [
          "Use \\n everywhere",
          "Use triple quotes: '''...''' or \"\"\"...\"\"\"",
          "Not possible",
          "Use |"
        ],
        correctAnswer: 1,
        explanation: "Triple quotes (''' or \"\"\") create multi-line strings preserving line breaks."
      },
      {
        question: "What are raw strings?",
        options: [
          "Unformatted strings",
          "Strings prefixed with r that treat backslashes literally",
          "Binary strings",
          "Empty strings"
        ],
        correctAnswer: 1,
        explanation: "Raw strings (r'...') treat backslashes as literal characters, not escape sequences."
      },
      {
        question: "What is string formatting?",
        options: [
          "Making strings uppercase",
          "Inserting variables into strings using f-strings, .format(), or %",
          "Removing spaces",
          "Splitting strings"
        ],
        correctAnswer: 1,
        explanation: "String formatting embeds values into strings: f'{name}', '{}'.format(name), '%s' % name."
      },
      {
        question: "Which is the modern way to format strings?",
        options: [
          "% formatting",
          "f-strings (f'...')",
          ".format()",
          "concatenation"
        ],
        correctAnswer: 1,
        explanation: "F-strings (Python 3.6+) are the recommended modern approach: f'Hello {name}'."
      },
      {
        question: "What does f'{x:.2f}' do?",
        options: [
          "Multiplies x by 2",
          "Formats x as a float with 2 decimal places",
          "Creates an error",
          "Converts x to string"
        ],
        correctAnswer: 1,
        explanation: ":.2f formats a number as a float with 2 decimal places: f'{3.14159:.2f}' = '3.14'."
      },
      {
        question: "Can you change a character in a string after creation?",
        options: [
          "Yes, using s[0] = 'x'",
          "No, strings are immutable",
          "Only uppercase strings",
          "Only with special methods"
        ],
        correctAnswer: 1,
        explanation: "Strings are immutable - you cannot modify them in place. Create a new string instead."
      },
      {
        question: "What does 'hello'.upper() return?",
        options: [
          "'hello'",
          "'HELLO'",
          "'Hello'",
          "Error"
        ],
        correctAnswer: 1,
        explanation: "upper() returns a new string with all characters uppercase: 'HELLO'."
      },
      {
        question: "Does 'hello'.upper() modify the original string?",
        options: [
          "Yes, it changes 'hello' to 'HELLO'",
          "No, it returns a new string; original is unchanged",
          "Only if assigned back",
          "Depends on Python version"
        ],
        correctAnswer: 1,
        explanation: "String methods return new strings without modifying the original (immutability)."
      },
      {
        question: "What does 'hello world'.split() return?",
        options: [
          "'hello', 'world'",
          "['hello', 'world']",
          "('hello', 'world')",
          "Error"
        ],
        correctAnswer: 1,
        explanation: "split() returns a list of strings: ['hello', 'world']."
      },
      {
        question: "What does ' hello '.strip() return?",
        options: [
          "' hello '",
          "'hello'",
          "'hello'",
          "Error"
        ],
        correctAnswer: 1,
        explanation: "strip() removes leading and trailing whitespace: 'hello'."
      },
      {
        question: "What does 'hello'.find('l') return?",
        options: [
          "'l'",
          "2 (index of first 'l')",
          "True",
          "[2, 3]"
        ],
        correctAnswer: 1,
        explanation: "find() returns the index of the first occurrence: 2."
      },
      {
        question: "What does 'hello'.count('l') return?",
        options: [
          "1",
          "2",
          "True",
          "[2, 3]"
        ],
        correctAnswer: 1,
        explanation: "count() returns how many times the substring appears: 2."
      },
      {
        question: "What does 'hello'.replace('l', 'L') return?",
        options: [
          "'heLlo'",
          "'heLLo'",
          "'hello'",
          "'HELLO'"
        ],
        correctAnswer: 1,
        explanation: "replace() replaces all occurrences: 'heLLo'."
      },
      {
        question: "What is the result of 'abc' in 'abcdef'?",
        options: [
          "False",
          "True",
          "0",
          "Error"
        ],
        correctAnswer: 1,
        explanation: "'in' checks if a substring exists: 'abc' is in 'abcdef', returns True."
      },
      {
        question: "What does 'hello'[1:4] return?",
        options: [
          "'hel'",
          "'ell'",
          "'ello'",
          "'hell'"
        ],
        correctAnswer: 1,
        explanation: "Slicing [1:4] returns characters from index 1 up to (not including) 4: 'ell'."
      },
      {
        question: "What does 'hello'[::-1] return?",
        options: [
          "'hello'",
          "'olleh'",
          "'h'",
          "Error"
        ],
        correctAnswer: 1,
        explanation: "[::-1] reverses the string using negative step: 'olleh'."
      },
      {
        question: "What does input() always return?",
        options: [
          "An integer",
          "A string",
          "Whatever type the user enters",
          "None"
        ],
        correctAnswer: 1,
        explanation: "input() always returns a string, regardless of what the user types."
      },
      {
        question: "How do you read an integer from user input?",
        options: [
          "input(int)",
          "int(input())",
          "input().int()",
          "read_int()"
        ],
        correctAnswer: 1,
        explanation: "Wrap input() with int(): int(input()) converts the string to an integer."
      },
      {
        question: "What happens if the user enters 'abc' for int(input())?",
        options: [
          "Returns 0",
          "Raises ValueError",
          "Returns None",
          "Returns 'abc'"
        ],
        correctAnswer: 1,
        explanation: "int() raises ValueError when given a non-numeric string."
      },
      {
        question: "What does print(x, y, z) do?",
        options: [
          "Prints x only",
          "Prints x, y, z separated by spaces",
          "Creates an error",
          "Prints x+y+z"
        ],
        correctAnswer: 1,
        explanation: "print() with multiple arguments prints them separated by spaces (default)."
      },
      {
        question: "How do you print without a newline at the end?",
        options: [
          "print(x, nonewline)",
          "print(x, end='')",
          "print(x, break=False)",
          "printf(x)"
        ],
        correctAnswer: 1,
        explanation: "Use end parameter: print(x, end='') removes the newline."
      },
      {
        question: "What does print(x, y, sep='-') do?",
        options: [
          "Prints x-y",
          "Prints x and y separated by '-'",
          "Subtracts y from x",
          "Creates an error"
        ],
        correctAnswer: 1,
        explanation: "sep parameter changes the separator: print(1, 2, sep='-') outputs '1-2'."
      },
      {
        question: "What is the difference between print(x) and return x?",
        options: [
          "No difference",
          "print() displays output; return sends value back to caller in a function",
          "return is deprecated",
          "print is only for strings"
        ],
        correctAnswer: 1,
        explanation: "print() outputs to console; return passes a value back from a function."
      },
      {
        question: "What does the 'and' operator do?",
        options: [
          "Adds two values",
          "Returns True only if both operands are True",
          "Concatenates strings",
          "Compares values"
        ],
        correctAnswer: 1,
        explanation: "'and' is a logical operator: True and True = True, otherwise False."
      },
      {
        question: "What does the 'or' operator do?",
        options: [
          "Divides values",
          "Returns True if at least one operand is True",
          "Subtracts values",
          "Creates options"
        ],
        correctAnswer: 1,
        explanation: "'or' returns True if at least one operand is True."
      },
      {
        question: "What does 'not True' evaluate to?",
        options: [
          "True",
          "False",
          "None",
          "Error"
        ],
        correctAnswer: 1,
        explanation: "'not' negates a boolean: not True = False, not False = True."
      },
      {
        question: "What is short-circuit evaluation?",
        options: [
          "Fast code execution",
          "Logical operators stop evaluation early if result is determined",
          "A type of loop",
          "An error handling technique"
        ],
        correctAnswer: 1,
        explanation: "'and' stops if first is False; 'or' stops if first is True (efficiency optimization)."
      },
      {
        question: "What does x += 5 do?",
        options: [
          "Compares x and 5",
          "Adds 5 to x (equivalent to x = x + 5)",
          "Creates x with value 5",
          "Subtracts 5 from x"
        ],
        correctAnswer: 1,
        explanation: "+= is augmented assignment: x += 5 means x = x + 5."
      },
      {
        question: "Which augmented assignment operator exists in Python?",
        options: [
          "++",
          "*=",
          "===",
          "--"
        ],
        correctAnswer: 1,
        explanation: "Python has +=, -=, *=, /=, //=, %=, **=. It doesn't have ++ or --."
      },
      {
        question: "What is the result of 10 > 5 and 3 < 1?",
        options: [
          "True",
          "False",
          "None",
          "Error"
        ],
        correctAnswer: 1,
        explanation: "10 > 5 is True, but 3 < 1 is False. True and False = False."
      },
      {
        question: "What does 5 < x < 10 check?",
        options: [
          "Syntax error",
          "If x is between 5 and 10 (chained comparison)",
          "If 5 < x only",
          "If x < 10 only"
        ],
        correctAnswer: 1,
        explanation: "Python supports chained comparisons: 5 < x < 10 checks if x is between 5 and 10."
      },
      {
        question: "What is the result of '3' + '3'?",
        options: [
          "6",
          "'33'",
          "Error",
          "'3 3'"
        ],
        correctAnswer: 1,
        explanation: "+ with strings concatenates: '3' + '3' = '33' (not arithmetic)."
      },
      {
        question: "What is the result of '3' * 3?",
        options: [
          "9",
          "'333'",
          "Error",
          "'3 3 3'"
        ],
        correctAnswer: 1,
        explanation: "String * int repeats the string: '3' * 3 = '333'."
      },
      {
        question: "Can you add a string and an integer directly?",
        options: [
          "Yes, always",
          "No, causes TypeError; must convert first",
          "Only in Python 3",
          "Only positive integers"
        ],
        correctAnswer: 1,
        explanation: "'hello' + 5 raises TypeError. Convert first: 'hello' + str(5)."
      },
      {
        question: "What is type casting?",
        options: [
          "Changing variable names",
          "Converting a value from one type to another",
          "Creating new types",
          "Deleting types"
        ],
        correctAnswer: 1,
        explanation: "Type casting converts values: int('5'), str(10), float('3.14')."
      },
      {
        question: "What does str(123) return?",
        options: [
          "123",
          "'123'",
          "Error",
          "None"
        ],
        correctAnswer: 1,
        explanation: "str() converts to string: str(123) = '123'."
      }
    ]
  },

  // Block 3: Control Flow (25% - ~50 questions)
  "controlflow": {
    title: "Control Flow - Conditional Blocks and Loops",
    description: "if/elif/else, while, for, break, continue, and logic",
    questions: [
      {
        question: "What is control flow?",
        options: [
          "Data flow between functions",
          "The order in which code statements are executed",
          "Variable scope",
          "Error handling"
        ],
        correctAnswer: 1,
        explanation: "Control flow determines the order of code execution using conditionals and loops."
      },
      {
        question: "What is the correct syntax for an if statement?",
        options: [
          "if (x > 5) { }",
          "if x > 5:",
          "if x > 5 then:",
          "if x > 5;"
        ],
        correctAnswer: 1,
        explanation: "Python uses 'if condition:' with a colon, no parentheses required."
      },
      {
        question: "What happens if the if condition is False and there's no else?",
        options: [
          "Error",
          "Code in if block is skipped, execution continues after",
          "Program stops",
          "Returns None"
        ],
        correctAnswer: 1,
        explanation: "If condition is False and no else exists, the if block is skipped."
      },
      {
        question: "What is elif short for?",
        options: [
          "Else conditional",
          "Else if",
          "End if",
          "Error if"
        ],
        correctAnswer: 1,
        explanation: "'elif' is short for 'else if' - checks another condition if previous was False."
      },
      {
        question: "Can you have multiple elif statements?",
        options: [
          "No, only one",
          "Yes, as many as needed",
          "Maximum two",
          "Only in Python 3"
        ],
        correctAnswer: 1,
        explanation: "You can have unlimited elif blocks to check multiple conditions."
      },
      {
        question: "What is the purpose of the else block?",
        options: [
          "To check another condition",
          "To execute when all previous conditions are False",
          "To end the program",
          "To raise an error"
        ],
        correctAnswer: 1,
        explanation: "'else' executes only when all previous if/elif conditions are False."
      },
      {
        question: "Can you have an else without an if?",
        options: [
          "Yes, standalone else is allowed",
          "No, else requires a preceding if/elif",
          "Only in loops",
          "Only in functions"
        ],
        correctAnswer: 1,
        explanation: "'else' must follow an if or elif statement - it can't be standalone."
      },
      {
        question: "What is a nested if statement?",
        options: [
          "An if inside a function",
          "An if statement inside another if statement",
          "Multiple elif statements",
          "An if with multiple conditions"
        ],
        correctAnswer: 1,
        explanation: "Nested if means an if statement inside another if block's body."
      },
      {
        question: "What is the ternary operator in Python?",
        options: [
          "?: operator",
          "value_if_true if condition else value_if_false",
          "Python doesn't have one",
          "if ? then : else"
        ],
        correctAnswer: 1,
        explanation: "Python's ternary: x = 10 if score > 50 else 0."
      },
      {
        question: "What does the while loop do?",
        options: [
          "Iterates over a sequence",
          "Repeats while a condition is True",
          "Runs exactly 10 times",
          "Creates a delay"
        ],
        correctAnswer: 1,
        explanation: "'while' continues looping as long as its condition remains True."
      },
      {
        question: "What is an infinite loop?",
        options: [
          "A very long loop",
          "A loop that never terminates because its condition never becomes False",
          "A loop with no body",
          "A for loop"
        ],
        correctAnswer: 1,
        explanation: "Infinite loop: while True: or a condition that never becomes False."
      },
      {
        question: "How do you exit an infinite loop?",
        options: [
          "Wait for it to finish",
          "Use break statement or Ctrl+C",
          "Restart Python",
          "Use stop command"
        ],
        correctAnswer: 1,
        explanation: "'break' exits the loop, or Ctrl+C interrupts the program."
      },
      {
        question: "What does the for loop do?",
        options: [
          "Loops while a condition is True",
          "Iterates over a sequence (list, range, string, etc.)",
          "Runs forever",
          "Creates variables"
        ],
        correctAnswer: 1,
        explanation: "'for' iterates over items in a sequence: for item in sequence:."
      },
      {
        question: "What does range(5) produce?",
        options: [
          "[0, 1, 2, 3, 4, 5]",
          "Numbers 0, 1, 2, 3, 4",
          "[1, 2, 3, 4, 5]",
          "5"
        ],
        correctAnswer: 1,
        explanation: "range(5) generates 0 through 4 (start at 0, stop before 5)."
      },
      {
        question: "What does range(1, 10) produce?",
        options: [
          "0 through 10",
          "1 through 9",
          "1 through 10",
          "[1, 10]"
        ],
        correctAnswer: 1,
        explanation: "range(start, stop) goes from start up to (but not including) stop."
      },
      {
        question: "What does range(0, 10, 2) produce?",
        options: [
          "0, 2, 4, 6, 8",
          "0, 2, 4, 6, 8",
          "0, 1, 2",
          "2, 4, 6, 8, 10"
        ],
        correctAnswer: 0,
        explanation: "range(start, stop, step) with step=2 generates even numbers: 0, 2, 4, 6, 8."
      },
      {
        question: "Can you iterate directly over a string?",
        options: [
          "No, must convert first",
          "Yes, for char in 'hello': works",
          "Only in Python 3",
          "Only lowercase strings"
        ],
        correctAnswer: 1,
        explanation: "Strings are iterable: for c in 'hello': iterates over each character."
      },
      {
        question: "What does break do in a loop?",
        options: [
          "Pauses the loop",
          "Immediately exits the loop",
          "Skips to next iteration",
          "Restarts the loop"
        ],
        correctAnswer: 1,
        explanation: "'break' immediately exits the innermost loop."
      },
      {
        question: "What does continue do in a loop?",
        options: [
          "Exits the loop",
          "Skips the rest of the current iteration and goes to next",
          "Restarts the loop",
          "Pauses execution"
        ],
        correctAnswer: 1,
        explanation: "'continue' skips remaining code in current iteration and starts next iteration."
      },
      {
        question: "Can you use break in an if statement outside a loop?",
        options: [
          "Yes, to exit the if",
          "No, break only works in loops",
          "Only in Python 3",
          "Only with else"
        ],
        correctAnswer: 1,
        explanation: "'break' is only valid inside loops (for/while), not in standalone if statements."
      },
      {
        question: "What does else do in a loop?",
        options: [
          "Errors are not allowed",
          "Executes if loop completes normally (not via break)",
          "Always executes after loop",
          "Handles loop errors"
        ],
        correctAnswer: 1,
        explanation: "Loop else executes only if the loop completes without hitting a break."
      },
      {
        question: "Does else after a while loop execute if you use break?",
        options: [
          "Yes, always",
          "No, break skips the else",
          "Only sometimes",
          "Syntax error"
        ],
        correctAnswer: 1,
        explanation: "If break exits the loop, the else block is skipped."
      },
      {
        question: "Can you nest loops?",
        options: [
          "No, not allowed",
          "Yes, you can have loops inside loops",
          "Only for loops",
          "Only while loops"
        ],
        correctAnswer: 1,
        explanation: "Loops can be nested: for i in range(3): for j in range(3):."
      },
      {
        question: "Does break exit all nested loops?",
        options: [
          "Yes, exits all loops",
          "No, only exits the innermost loop containing the break",
          "Only if used twice",
          "Depends on indentation"
        ],
        correctAnswer: 1,
        explanation: "'break' only exits the current (innermost) loop, not outer loops."
      },
      {
        question: "How do you iterate over a list?",
        options: [
          "while list:",
          "for item in list:",
          "foreach item in list:",
          "iterate(list)"
        ],
        correctAnswer: 1,
        explanation: "Use 'for item in list:' to iterate over list elements."
      },
      {
        question: "How do you iterate over indices of a list?",
        options: [
          "for i in list:",
          "for i in range(len(list)):",
          "for i = 0; i < len(list); i++:",
          "for index(list):"
        ],
        correctAnswer: 1,
        explanation: "Use range(len(list)) to get indices: for i in range(len(my_list)):."
      },
      {
        question: "What does enumerate() do?",
        options: [
          "Counts items",
          "Returns (index, value) pairs when iterating",
          "Creates a list",
          "Sorts items"
        ],
        correctAnswer: 1,
        explanation: "enumerate() provides index and value: for i, val in enumerate(list):."
      },
      {
        question: "What is the output of: for i in range(3): print(i)",
        options: [
          "1 2 3",
          "0 1 2",
          "0 1 2 3",
          "3"
        ],
        correctAnswer: 1,
        explanation: "range(3) generates 0, 1, 2. Each is printed on a new line."
      },
      {
        question: "Can you modify a list while iterating over it?",
        options: [
          "Yes, always safe",
          "Not recommended; can cause unexpected behavior",
          "Only with while loops",
          "Only in Python 2"
        ],
        correctAnswer: 1,
        explanation: "Modifying a list during iteration can skip elements or cause errors."
      },
      {
        question: "What is a sentinel value?",
        options: [
          "A maximum value",
          "A special value used to signal the end of input/data",
          "An error code",
          "A loop counter"
        ],
        correctAnswer: 1,
        explanation: "Sentinel values (like '' or -1) signal when to stop reading input or processing."
      },
      {
        question: "What pattern reads input until empty string?",
        options: [
          "for line in input():",
          "while True: line = input(); if not line: break",
          "while input():",
          "forever input()"
        ],
        correctAnswer: 1,
        explanation: "Read until sentinel: while True: x = input(); if not x: break."
      },
      {
        question: "What does pass do?",
        options: [
          "Passes a value to a function",
          "A null operation placeholder that does nothing",
          "Skips to next iteration",
          "Exits the loop"
        ],
        correctAnswer: 1,
        explanation: "'pass' is a no-op placeholder: useful when syntax requires a statement but you want no action."
      },
      {
        question: "When would you use pass?",
        options: [
          "Never, it's useless",
          "As a placeholder in empty functions, loops, or conditionals during development",
          "To exit loops",
          "To print values"
        ],
        correctAnswer: 1,
        explanation: "'pass' is used as a placeholder: if x: pass # TODO: implement later."
      },
      {
        question: "What is a loop counter?",
        options: [
          "A built-in function",
          "A variable that tracks the number of iterations",
          "The range function",
          "An error counter"
        ],
        correctAnswer: 1,
        explanation: "Loop counters track iterations: count = 0; while condition: count += 1."
      },
      {
        question: "How do you create a countdown loop?",
        options: [
          "for i in range(5, 0)",
          "for i in range(5, 0, -1)",
          "for i in countdown(5)",
          "while i > 0 after i = 5"
        ],
        correctAnswer: 1,
        explanation: "Use negative step: for i in range(5, 0, -1): gives 5, 4, 3, 2, 1."
      },
      {
        question: "What is short-circuit evaluation in conditions?",
        options: [
          "Fast if statements",
          "Logical operators stop evaluating once result is determined",
          "A type of loop",
          "An optimization technique"
        ],
        correctAnswer: 1,
        explanation: "In 'A and B', if A is False, B isn't evaluated. In 'A or B', if A is True, B isn't evaluated."
      },
      {
        question: "What is the result of True or (1/0)?",
        options: [
          "Error",
          "True (no error because 1/0 is not evaluated)",
          "False",
          "Infinity"
        ],
        correctAnswer: 1,
        explanation: "'or' short-circuits: since True is already True, the second part isn't evaluated."
      },
      {
        question: "What is the result of False and (1/0)?",
        options: [
          "Error",
          "False (no error because 1/0 is not evaluated)",
          "True",
          "0"
        ],
        correctAnswer: 1,
        explanation: "'and' short-circuits: since False makes the whole expression False, 1/0 isn't evaluated."
      },
      {
        question: "Can you have an if without a body?",
        options: [
          "Yes, leave it empty",
          "No, but you can use 'pass' as a placeholder",
          "Yes, with semicolon",
          "Only in functions"
        ],
        correctAnswer: 1,
        explanation: "Python requires at least one statement in a block. Use 'pass' if needed: if x: pass."
      },
      {
        question: "What is the walrus operator?",
        options: [
          "A marine operator",
          ":= - assigns and returns a value in expressions (Python 3.8+)",
          "A comparison operator",
          "A loop operator"
        ],
        correctAnswer: 1,
        explanation: "Walrus operator := assigns in expressions: if (n := len(text)) > 10:."
      },
      {
        question: "What does 'for _ in range(5):' mean?",
        options: [
          "Syntax error",
          "Loop 5 times without using the loop variable (underscore convention)",
          "Loop forever",
          "Create 5 underscores"
        ],
        correctAnswer: 1,
        explanation: "Underscore _ conventionally indicates an unused variable: loop 5 times, ignore the counter."
      },
      {
        question: "Can you use break in a nested loop to exit all loops?",
        options: [
          "Yes, break exits all",
          "No, break only exits innermost loop; use flag or function return",
          "Yes, with break 2",
          "Only in Python 3"
        ],
        correctAnswer: 1,
        explanation: "'break' exits only the innermost loop. Use a flag variable or wrap in a function to exit all."
      },
      {
        question: "What is iteration?",
        options: [
          "Creating variables",
          "Repeating a process multiple times",
          "Error handling",
          "Function calling"
        ],
        correctAnswer: 1,
        explanation: "Iteration means repeating a process - done with for and while loops."
      },
      {
        question: "What is an iterable?",
        options: [
          "A loop type",
          "An object that can be iterated over (lists, strings, tuples, etc.)",
          "A function",
          "A variable"
        ],
        correctAnswer: 1,
        explanation: "Iterables are objects you can loop over: lists, tuples, strings, dictionaries, sets, etc."
      },
      {
        question: "Can you iterate over a dictionary?",
        options: [
          "No, never",
          "Yes, iterates over keys by default; use .items() for key-value pairs",
          "Only with while loops",
          "Only in Python 2"
        ],
        correctAnswer: 1,
        explanation: "for k in dict: iterates keys. for k, v in dict.items(): iterates key-value pairs."
      },
      {
        question: "What does zip() do?",
        options: [
          "Compresses files",
          "Combines multiple iterables element-wise",
          "Creates lists",
          "Sorts items"
        ],
        correctAnswer: 1,
        explanation: "zip() pairs elements from multiple iterables: zip([1,2], ['a','b']) → (1,'a'), (2,'b')."
      },
      {
        question: "What happens if you iterate zip() of different-length lists?",
        options: [
          "Error",
          "Stops at the shortest list",
          "Pads with None",
          "Repeats shorter list"
        ],
        correctAnswer: 1,
        explanation: "zip() stops when the shortest iterable is exhausted."
      },
      {
        question: "What is list comprehension used for?",
        options: [
          "Understanding lists",
          "Creating lists concisely with a loop in one line",
          "Deleting lists",
          "Sorting lists"
        ],
        correctAnswer: 1,
        explanation: "List comprehension: [expr for item in iterable if condition] creates lists concisely."
      },
      {
        question: "Can you use break in list comprehension?",
        options: [
          "Yes, with [break]",
          "No, break/continue don't work in comprehensions",
          "Only sometimes",
          "Only in Python 3"
        ],
        correctAnswer: 1,
        explanation: "Comprehensions don't support break/continue. Use regular loops for that."
      },
      {
        question: "What is the difference between while and for?",
        options: [
          "No difference",
          "while loops until condition is False; for iterates over a sequence",
          "for is faster",
          "while is deprecated"
        ],
        correctAnswer: 1,
        explanation: "while: condition-based. for: iteration over sequences. Use for when you know the range."
      }
    ]
  },

  // Block 4: Data Collections and Functions (28% - ~56 questions)
  "collections": {
    title: "Data Collections & Functions",
    description: "Lists, tuples, dictionaries, sets, functions, and scope",
    questions: [
      // Lists (15 questions)
      {
        question: "How do you create an empty list?",
        options: [
          "list()",
          "[] or list()",
          "{}",
          "new List()"
        ],
        correctAnswer: 1,
        explanation: "Empty list: [] or list(). {} creates an empty dict."
      },
      {
        question: "Are lists mutable or immutable?",
        options: [
          "Immutable",
          "Mutable (can be changed after creation)",
          "Depends on content",
          "Read-only"
        ],
        correctAnswer: 1,
        explanation: "Lists are mutable - you can add, remove, and modify elements."
      },
      {
        question: "How do you add an element to the end of a list?",
        options: [
          "list.add()",
          "list.append(element)",
          "list.push()",
          "list += element"
        ],
        correctAnswer: 1,
        explanation: "append() adds an element to the end: my_list.append(5)."
      },
      {
        question: "What does list.insert(1, 'x') do?",
        options: [
          "Replaces index 1",
          "Inserts 'x' at index 1, shifting others right",
          "Inserts at end",
          "Error"
        ],
        correctAnswer: 1,
        explanation: "insert(index, value) inserts at the specified position, shifting elements."
      },
      {
        question: "How do you remove the last element from a list?",
        options: [
          "list.removeLast()",
          "list.pop() or del list[-1]",
          "list.delete(-1)",
          "list[-1].remove()"
        ],
        correctAnswer: 1,
        explanation: "pop() removes and returns the last element. pop(i) removes at index i."
      },
      {
        question: "What does list.remove('x') do?",
        options: [
          "Removes all 'x' from list",
          "Removes the first occurrence of 'x'",
          "Removes at index x",
          "Error"
        ],
        correctAnswer: 1,
        explanation: "remove(value) removes the first occurrence of the value."
      },
      {
        question: "What happens if you try to remove a value that doesn't exist?",
        options: [
          "Returns None",
          "Raises ValueError",
          "Does nothing",
          "Removes last element"
        ],
        correctAnswer: 1,
        explanation: "remove() raises ValueError if the value isn't in the list."
      },
      {
        question: "What does list.extend([1, 2]) do?",
        options: [
          "Adds [1, 2] as a single element",
          "Adds elements 1 and 2 individually to the list",
          "Replaces the list",
          "Error"
        ],
        correctAnswer: 1,
        explanation: "extend() adds all elements from an iterable: list.extend([1,2]) adds 1, then 2."
      },
      {
        question: "What's the difference between append() and extend()?",
        options: [
          "No difference",
          "append() adds one item; extend() adds all items from an iterable",
          "extend() is faster",
          "append() is deprecated"
        ],
        correctAnswer: 1,
        explanation: "append([1,2]) adds list as one element. extend([1,2]) adds 1 and 2 separately."
      },
      {
        question: "How do you reverse a list in place?",
        options: [
          "list.reverse()",
          "list.reverse()",
          "reverse(list)",
          "list[::-1]"
        ],
        correctAnswer: 0,
        explanation: "list.reverse() reverses in place. list[::-1] creates a reversed copy."
      },
      {
        question: "How do you sort a list in place?",
        options: [
          "sorted(list)",
          "list.sort()",
          "sort(list)",
          "list.order()"
        ],
        correctAnswer: 1,
        explanation: "list.sort() sorts in place. sorted(list) returns a new sorted list."
      },
      {
        question: "What does list.index('x') return?",
        options: [
          "The value 'x'",
          "The index of the first occurrence of 'x'",
          "All indices of 'x'",
          "True/False"
        ],
        correctAnswer: 1,
        explanation: "index(value) returns the index of the first occurrence."
      },
      {
        question: "What does list.count('x') return?",
        options: [
          "The index of 'x'",
          "The number of times 'x' appears in the list",
          "True/False",
          "The first 'x'"
        ],
        correctAnswer: 1,
        explanation: "count(value) returns how many times the value appears."
      },
      {
        question: "Can lists contain different data types?",
        options: [
          "No, all must be same type",
          "Yes, lists can have mixed types",
          "Only numbers and strings",
          "Only in Python 3"
        ],
        correctAnswer: 1,
        explanation: "Lists are heterogeneous: [1, 'hello', 3.14, True] is valid."
      },
      {
        question: "How do you copy a list?",
        options: [
          "list2 = list1 (creates reference, not copy)",
          "list2 = list1.copy() or list2 = list1[:]",
          "list2 = copy(list1)",
          "list.clone()"
        ],
        correctAnswer: 1,
        explanation: "Use .copy() or [:] to create a shallow copy. = only creates a reference."
      },
      // Tuples (8 questions)
      {
        question: "What is the main difference between lists and tuples?",
        options: [
          "No difference",
          "Tuples are immutable (cannot be changed); lists are mutable",
          "Tuples are faster",
          "Tuples use different syntax"
        ],
        correctAnswer: 1,
        explanation: "Tuples are immutable - once created, they can't be modified."
      },
      {
        question: "How do you create a tuple?",
        options: [
          "[]",
          "(1, 2, 3) or 1, 2, 3",
          "{}",
          "tuple[1, 2, 3]"
        ],
        correctAnswer: 1,
        explanation: "Tuples use parentheses: (1, 2) or just commas: 1, 2."
      },
      {
        question: "How do you create a single-element tuple?",
        options: [
          "(element)",
          "(element,) with trailing comma",
          "[element]",
          "tuple(element)"
        ],
        correctAnswer: 1,
        explanation: "(5,) creates a tuple. (5) is just a parenthesized integer."
      },
      {
        question: "Can you change a tuple after creation?",
        options: [
          "Yes, using tuple[0] = x",
          "No, tuples are immutable",
          "Only with .append()",
          "Only in Python 3"
        ],
        correctAnswer: 1,
        explanation: "Tuples are immutable - attempting to modify raises TypeError."
      },
      {
        question: "Can you use indexing and slicing on tuples?",
        options: [
          "No, only on lists",
          "Yes, tuples support indexing and slicing",
          "Only indexing",
          "Only slicing"
        ],
        correctAnswer: 1,
        explanation: "Tuples support all sequence operations except modification."
      },
      {
        question: "Why use tuples instead of lists?",
        options: [
          "Tuples are slower",
          "For immutable data, memory efficiency, and use as dict keys",
          "Tuples store more data",
          "No reason"
        ],
        correctAnswer: 1,
        explanation: "Tuples: slightly faster, use less memory, can be dict keys, signal immutability."
      },
      {
        question: "Can tuples be used as dictionary keys?",
        options: [
          "No, never",
          "Yes, because they're immutable (hashable)",
          "Only empty tuples",
          "Only in Python 3"
        ],
        correctAnswer: 1,
        explanation: "Immutable types (including tuples) can be dict keys."
      },
      {
        question: "What is tuple unpacking?",
        options: [
          "Deleting tuples",
          "Assigning tuple elements to variables: a, b = (1, 2)",
          "Converting to list",
          "Merging tuples"
        ],
        correctAnswer: 1,
        explanation: "Tuple unpacking: a, b = (1, 2) assigns a=1, b=2."
      },
      // Dictionaries (15 questions)
      {
        question: "What is a dictionary?",
        options: [
          "A book",
          "A collection of key-value pairs",
          "A list with names",
          "A string"
        ],
        correctAnswer: 1,
        explanation: "Dictionaries store key-value pairs: {'name': 'Alice', 'age': 25}."
      },
      {
        question: "How do you create an empty dictionary?",
        options: [
          "[]",
          "{} or dict()",
          "()",
          "new Dict()"
        ],
        correctAnswer: 1,
        explanation: "Empty dict: {} or dict(). [] creates an empty list."
      },
      {
        question: "How do you access a dictionary value?",
        options: [
          "dict.key",
          "dict[key]",
          "dict(key)",
          "dict->key"
        ],
        correctAnswer: 1,
        explanation: "Access values with square brackets: my_dict['key']."
      },
      {
        question: "What happens if you access a non-existent key?",
        options: [
          "Returns None",
          "Raises KeyError",
          "Returns ''",
          "Creates the key"
        ],
        correctAnswer: 1,
        explanation: "Accessing a missing key raises KeyError. Use .get() for safe access."
      },
      {
        question: "What does dict.get(key, default) do?",
        options: [
          "Always raises error",
          "Returns dict[key] if exists, else returns default",
          "Deletes the key",
          "Creates the key"
        ],
        correctAnswer: 1,
        explanation: ".get(key, default) safely accesses values without raising errors."
      },
      {
        question: "How do you add or update a key-value pair?",
        options: [
          "dict.add(key, value)",
          "dict[key] = value",
          "dict.set(key, value)",
          "dict.put(key, value)"
        ],
        correctAnswer: 1,
        explanation: "dict[key] = value adds new pairs or updates existing ones."
      },
      {
        question: "Can dictionary keys be of any type?",
        options: [
          "Yes, any type",
          "No, keys must be immutable (hashable)",
          "Only strings",
          "Only integers"
        ],
        correctAnswer: 1,
        explanation: "Keys must be immutable: strings, numbers, tuples (but not lists or dicts)."
      },
      {
        question: "Can you use a list as a dictionary key?",
        options: [
          "Yes, always",
          "No, lists are mutable (not hashable)",
          "Only empty lists",
          "Only in Python 3"
        ],
        correctAnswer: 1,
        explanation: "Lists are mutable and can't be hashed, so they can't be keys."
      },
      {
        question: "How do you remove a key-value pair?",
        options: [
          "dict.remove(key)",
          "del dict[key] or dict.pop(key)",
          "dict.delete(key)",
          "dict[key].remove()"
        ],
        correctAnswer: 1,
        explanation: "Use del dict[key] or dict.pop(key) to remove pairs."
      },
      {
        question: "What does dict.keys() return?",
        options: [
          "A list of keys",
          "A view object of all keys",
          "A tuple of keys",
          "A string of keys"
        ],
        correctAnswer: 1,
        explanation: ".keys() returns a view object (convert to list with list(dict.keys()))."
      },
      {
        question: "What does dict.values() return?",
        options: [
          "A list of values",
          "A view object of all values",
          "A tuple of values",
          "A string of values"
        ],
        correctAnswer: 1,
        explanation: ".values() returns a view object of all values."
      },
      {
        question: "What does dict.items() return?",
        options: [
          "A list of keys",
          "A view object of (key, value) tuples",
          "A string",
          "An error"
        ],
        correctAnswer: 1,
        explanation: ".items() returns (key, value) pairs: useful for iteration."
      },
      {
        question: "How do you iterate over dictionary keys?",
        options: [
          "for key in dict.keys():",
          "for key in dict: (iterates keys by default)",
          "for dict:",
          "iterate(dict)"
        ],
        correctAnswer: 1,
        explanation: "'for key in dict:' iterates over keys by default."
      },
      {
        question: "How do you iterate over both keys and values?",
        options: [
          "for key, value in dict:",
          "for key, value in dict.items():",
          "for dict.items:",
          "iterate(dict, keys=True, values=True)"
        ],
        correctAnswer: 1,
        explanation: "'for k, v in dict.items():' unpacks key-value pairs."
      },
      {
        question: "Are dictionaries ordered in Python 3.7+?",
        options: [
          "No, always unordered",
          "Yes, they maintain insertion order",
          "Only sometimes",
          "Only with OrderedDict"
        ],
        correctAnswer: 1,
        explanation: "Python 3.7+ guarantees insertion order preservation in dictionaries."
      },
      // Sets (8 questions)
      {
        question: "What is a set?",
        options: [
          "An ordered collection",
          "An unordered collection of unique elements",
          "A type of list",
          "A dictionary without values"
        ],
        correctAnswer: 1,
        explanation: "Sets store unique elements in no particular order."
      },
      {
        question: "How do you create a set?",
        options: [
          "[]",
          "{1, 2, 3} or set([1, 2, 3])",
          "(1, 2, 3)",
          "new Set()"
        ],
        correctAnswer: 1,
        explanation: "Sets use curly braces: {1, 2, 3} or set() constructor."
      },
      {
        question: "How do you create an empty set?",
        options: [
          "{}",
          "set()",
          "[]",
          "empty_set"
        ],
        correctAnswer: 1,
        explanation: "{} creates an empty dict, not set. Use set() for empty set."
      },
      {
        question: "What happens to duplicates in a set?",
        options: [
          "Raises error",
          "Automatically removed (sets store only unique values)",
          "Kept",
          "Converted to list"
        ],
        correctAnswer: 1,
        explanation: "Sets automatically remove duplicates: {1, 1, 2} becomes {1, 2}."
      },
      {
        question: "How do you add an element to a set?",
        options: [
          "set.append(element)",
          "set.add(element)",
          "set.insert(element)",
          "set += element"
        ],
        correctAnswer: 1,
        explanation: "Use .add() to add an element to a set."
      },
      {
        question: "What does set1.union(set2) do?",
        options: [
          "Finds common elements",
          "Returns all unique elements from both sets",
          "Subtracts set2 from set1",
          "Compares sets"
        ],
        correctAnswer: 1,
        explanation: "union() (or |) combines sets: {1, 2} | {2, 3} = {1, 2, 3}."
      },
      {
        question: "What does set1.intersection(set2) do?",
        options: [
          "Combines all elements",
          "Returns only common elements",
          "Removes elements",
          "Sorts elements"
        ],
        correctAnswer: 1,
        explanation: "intersection() (or &) finds common elements: {1, 2} & {2, 3} = {2}."
      },
      {
        question: "What does set1.difference(set2) do?",
        options: [
          "Combines sets",
          "Returns elements in set1 but not in set2",
          "Returns common elements",
          "Compares sizes"
        ],
        correctAnswer: 1,
        explanation: "difference() (or -) finds elements unique to set1: {1, 2} - {2, 3} = {1}."
      },
      // Functions (10 questions)
      {
        question: "How do you define a function in Python?",
        options: [
          "function name():",
          "def name():",
          "func name():",
          "define name():"
        ],
        correctAnswer: 1,
        explanation: "Use 'def' keyword: def my_function():."
      },
      {
        question: "What does the return statement do?",
        options: [
          "Prints a value",
          "Exits the function and optionally sends a value back",
          "Starts the function",
          "Deletes the function"
        ],
        correctAnswer: 1,
        explanation: "'return' exits the function and sends a value back to the caller."
      },
      {
        question: "What happens if a function has no return statement?",
        options: [
          "Error",
          "Returns None",
          "Returns 0",
          "Returns ''"
        ],
        correctAnswer: 1,
        explanation: "Functions without return automatically return None."
      },
      {
        question: "What are function parameters?",
        options: [
          "Return values",
          "Variables in the function definition that receive arguments",
          "Function names",
          "Output values"
        ],
        correctAnswer: 1,
        explanation: "Parameters are placeholders in the definition; arguments are values passed when calling."
      },
      {
        question: "What is the difference between parameters and arguments?",
        options: [
          "No difference",
          "Parameters are in definition; arguments are actual values passed",
          "Parameters are faster",
          "Arguments are optional"
        ],
        correctAnswer: 1,
        explanation: "def func(param): defines parameter. func(arg) passes argument."
      },
      {
        question: "What are default parameters?",
        options: [
          "Required parameters",
          "Parameters with default values, making them optional",
          "The first parameter",
          "Return values"
        ],
        correctAnswer: 1,
        explanation: "Default parameters: def func(x=10): allows calling func() without arguments."
      },
      {
        question: "Can default parameters come before non-default ones?",
        options: [
          "Yes, any order",
          "No, default parameters must come after non-default",
          "Only sometimes",
          "Only in Python 3"
        ],
        correctAnswer: 1,
        explanation: "SyntaxError: def func(x=1, y): is invalid. Correct: def func(y, x=1):."
      },
      {
        question: "What does *args do?",
        options: [
          "Multiplies arguments",
          "Collects variable number of positional arguments into a tuple",
          "Creates errors",
          "Makes arguments optional"
        ],
        correctAnswer: 1,
        explanation: "*args collects extra positional arguments: def func(*args): allows func(1, 2, 3)."
      },
      {
        question: "What does **kwargs do?",
        options: [
          "Raises arguments to a power",
          "Collects keyword arguments into a dictionary",
          "Compares arguments",
          "Repeats arguments"
        ],
        correctAnswer: 1,
        explanation: "**kwargs collects keyword arguments: def func(**kwargs): allows func(a=1, b=2)."
      },
      {
        question: "What is variable scope?",
        options: [
          "Variable size",
          "The region where a variable is accessible",
          "Variable type",
          "Variable name"
        ],
        correctAnswer: 1,
        explanation: "Scope determines where variables can be accessed: local, enclosing, global, built-in."
      }
    ]
  }
};

// Function to get all questions from a category
export function getQuestionsByCategory(category) {
  return practiceQuestions[category]?.questions || [];
}

// Function to get random questions from all categories
export function getRandomQuestions(count = 20) {
  const allQuestions = [];

  // Collect all questions from all categories
  Object.keys(practiceQuestions).forEach(category => {
    allQuestions.push(...practiceQuestions[category].questions);
  });

  // Shuffle and return requested number
  const shuffled = allQuestions.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, Math.min(count, shuffled.length));
}

// Function to get questions by difficulty (based on category)
export function getQuestionsByBlock(blockName) {
  return practiceQuestions[blockName]?.questions || [];
}

// Function to get all categories
export function getAllCategories() {
  return Object.keys(practiceQuestions).map(key => ({
    id: key,
    title: practiceQuestions[key].title,
    description: practiceQuestions[key].description,
    questionCount: practiceQuestions[key].questions.length
  }));
}

// Get total question count
export function getTotalQuestionCount() {
  let total = 0;
  Object.keys(practiceQuestions).forEach(category => {
    total += practiceQuestions[category].questions.length;
  });
  return total;
}
